/**
 * Header Scroll Behavior
 */
(function () {
  "use strict";

  const HeaderScroll = {
    init() {
      const header = document.querySelector("[data-header]");
      if (!header) return;

      let lastScrollY = window.scrollY;
      let showHeader = true;
      let atTop = true;
      const headerHeight = header.offsetHeight;

      const updateHeader = () => {
        const currentY = window.scrollY;
        const newHeaderHeight = header.offsetHeight;
        atTop = currentY < newHeaderHeight;

        if (currentY < lastScrollY) {
          // Scrolling up
          showHeader = true;
        } else if (currentY > lastScrollY) {
          // Scrolling down
          showHeader = false;
        }

        header.style.transform =
          showHeader || atTop ? "translateY(0)" : "translateY(-100%)";

        // Update logo invert class - DISABLED
        // const logo = header.querySelector('[data-header-logo]');
        // if (logo) {
        //   if (atTop) {
        //     logo.classList.remove('invert-100');
        //     logo.classList.add('invert-0');
        //   } else {
        //     logo.classList.remove('invert-0');
        //     logo.classList.add('invert-100');
        //   }
        // }

        lastScrollY = currentY;

        // Update header spacer height
        const spacer = document.querySelector("[data-header-spacer]");
        if (spacer) {
          spacer.style.height = `${newHeaderHeight}px`;
        }
      };

      // Set initial state
      updateHeader();
      window.addEventListener("scroll", updateHeader, { passive: true });
      window.addEventListener("resize", updateHeader, { passive: true });
    },
  };

  window.HeaderScroll = HeaderScroll;
})();

